import React, {Component} from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import Checkbox from '@material-ui/core/Checkbox'

import PaperBlock from "./../../ui/PaperBlock"

/**
 * <Item show onCheck = {show} />
 */

class Item extends Component {

	state = {
		checked: false
	}

	render() {

		return <ListItem>

			<Checkbox
				checked = {this.props.show.checked}
				onClick = {e => {
					e.stopPropagation()
					if (this.props.onCheck) {
						this.props.onCheck(this.props.show)
					}
				}}
			/>

			<ListItemText primary = {this.props.show.name}/>

		</ListItem>

	}

}

/**
 * <ShowList shows onCheckShow = {show}/>
 */

class ShowList extends Component {

	render() {

		if (!this.props.shows || !this.props.shows.length) {
			return null
		}

		return <PaperBlock>
			<List>
				{this.props.shows.map((show, n) => <Item
					show = {show}
					key = {n}
					onCheck = {this.props.onCheckShow}
				/>)}
			</List>
		</PaperBlock>

	}
}

export default ShowList
